import Phaser from 'phaser';
import { BootScene } from './scenes/Boot';
import { LobbyScene } from './scenes/LobbyScene';
import { GameScene } from './scenes/Game';
import { UIScene } from './scenes/UI';
import { GameOverScene } from './scenes/GameOver';
import { GAME_CONSTANTS } from './config/balance';

// 모바일 감지
const ua = navigator.userAgent;
const isUAMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
// iPadOS 13+ 는 Safari가 기본 "데스크톱 모드"로 동작해 UA에 "iPad"가 없고 "Macintosh"로 보고됨.
// → Mac 플랫폼인데 멀티터치(maxTouchPoints > 1)가 있으면 iPad로 간주 (일반 Mac은 0).
const isIPadOS = /Macintosh/i.test(ua) && navigator.maxTouchPoints > 1;
const isMobile = isUAMobile || isIPadOS;
const isTablet = (/iPad|Android/i.test(ua) && !/Mobile/i.test(ua)) || isIPadOS;

const config: Phaser.Types.Core.GameConfig = {
  type: Phaser.WEBGL,
  parent: 'game-container',
  backgroundColor: '#1a2634',
  physics: {
    default: 'arcade',
    arcade: {
      gravity: { x: 0, y: 0 },
      debug: false,
    },
  },
  scene: [BootScene, LobbyScene, GameScene, UIScene, GameOverScene],
  scale: {
    mode: Phaser.Scale.RESIZE,
    autoCenter: Phaser.Scale.CENTER_BOTH,
  },
  input: {
    activePointers: 3, // 멀티터치 지원
    touch: {
      capture: true,
    },
  },
  render: {
    antialias: true,
    pixelArt: false,
    roundPixels: false,
    antialiasGL: true,
  },
};

console.log(`Landlock v${__APP_VERSION__} (build ${__BUILD_TIME__}) - Starting...`);
console.log('Game Constants:', GAME_CONSTANTS);
console.log('Device:', isMobile ? 'Mobile' : isTablet ? 'Tablet' : 'Desktop');

// 전역 변수로 모바일 여부 저장
(window as any).isMobileDevice = isMobile;
(window as any).isTabletDevice = isTablet;

const game = new Phaser.Game(config);

// 화면 회전/리사이즈 시 Phaser 캔버스 버퍼를 부모 크기에 강제 동기화.
// Scale.RESIZE 모드가 모바일 회전 시 부모 크기 변화를 놓치는 경우가 있어
// (버퍼는 세로 크기인데 CSS가 가로로 늘려서 화면 왜곡 + 터치 좌표 어긋남)
// 명시적으로 refresh를 호출한다. 회전 직후 레이아웃 안정화를 위해 지연 재호출 포함.
const refreshScale = () => {
  game.scale.refresh();
  setTimeout(() => game.scale.refresh(), 300);
};
window.addEventListener('resize', refreshScale);
window.addEventListener('orientationchange', refreshScale);

// 운영 디버깅용 (콘솔에서 스케일/카메라 상태 점검)
(window as any).__landlockGame = game;
